import { connect } from "react-redux";
import { AtendimentoViewProps, mapDispatchToAtendimentoProps, mapStateToAtendimentoProps } from "../atendimento.controller";
import { Atendimento } from "../atendimento.model";
import { Select as ViewList } from "../../../components/select";
import { Box, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";

 
export const columnsAtendimento: GridColDef[] = [
    { field: 'medico', headerName: 'Medico', flex: 1, valueFormatter:(value,row:Atendimento)=>row.medico.nome },
    { field: 'sala_atendimento', headerName: 'Sala', flex: 1, valueFormatter:(value,row:Atendimento)=>row.sala_atendimento.descricao },
]

function AtendimentoList(props: AtendimentoViewProps) {
    const { atendimentoActions,atendimentoState } = props
    const { error, loadingRows, msg, row, rows, showAlert, showDialogExluir, status,showCadModal,changeList } = atendimentoState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue,setShowCadModal } = atendimentoActions
    console.log("AtendimentoList props ",props)

    useEffect(()=>{
        if(rows.length === 0)
            read()
    },[])

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    const handleAlterar = (row: any) => {
        console.log("chamou handleAlterar")
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        console.log("chamou handleCloseCadastro")
        setShowCadModal(false)
    }

    function Cadastro() {

    }

    const List = ()=>{
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={"Atendimentos Cadastrados"}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"data"}
                columns={columnsAtendimento}
                rows={rows}
                loading={loadingRows}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick:()=>read()
                }}
                ListItemTextPrimary={(row: Atendimento) => <Typography component={"span"}>{row.data}</Typography>}
            />
        )
    }

    return (
        <div className="modulo">
            <List />
        </div>
    )

}

export default connect(mapStateToAtendimentoProps,mapDispatchToAtendimentoProps)(AtendimentoList);
